import React from 'react';
export function Footer() {
  return <footer className="w-full bg-ink px-5 py-10 pb-24 text-cream/55 sm:px-8 lg:pb-10" data-id="element-50" data-mp="32wd2qgad7ltj">
      <div className="mx-auto w-full max-w-5xl" data-id="element-51" data-mp="3gg0xbxz0nnv0">
        <p className="font-display text-base font-bold uppercase tracking-tight text-cream" data-id="element-52" data-mp="32nuhkczrziw3">
          El Protocolo Anti-Inflación
        </p>
        <p className="mt-2 text-sm leading-relaxed" data-id="element-53" data-mp="36q92r3qx2uqj">
          Un producto digital de Creativo Digital.
          <br data-id="element-54" data-mp="3ugboz385h6h8" />
          Producto educativo sobre organización de compras.
        </p>

        <div className="mt-5 flex flex-wrap items-center gap-x-4 gap-y-2 text-sm" data-id="element-55" data-mp="37o38m5zzh95">
          <span data-id="element-56" data-mp="3lf58uv9exxoi">Contacto y soporte por email</span>
          <span className="text-cream/30" aria-hidden="true" data-id="element-57" data-mp="3lggaopjasvcz">
            ·
          </span>
          <a href="#" className="underline underline-offset-4 hover:text-cream" data-id="element-58" data-mp="3qblzbw434o4r">
            Política de Privacidad
          </a>
          <span className="text-cream/30" aria-hidden="true" data-id="element-59" data-mp="2ey08m6ikueh4">
            ·
          </span>
          <a href="#" className="underline underline-offset-4 hover:text-cream" data-id="element-60" data-mp="3l9k6xg5ljtev">
            Términos y Condiciones
          </a>
        </div>

        <p className="mt-5 text-xs leading-relaxed text-cream/35" data-id="element-61" data-mp="3gbikcl8ypbyn">
          © 2026 Creativo Digital. Los descuentos, reintegros y promociones pueden cambiar según
          banco, billetera o comercio.
        </p>
      </div>
    </footer>;
}